const $ = jQuery;

class Properties {
    constructor() {
        this.propertyAjax = null; // Will be set by AppAjax
    }

    setAjaxHandler(handler) {
        this.propertyAjax = handler;
    }
}

export default Properties; 